// extracted by mini-css-extract-plugin
module.exports = {"link":"MenuLink_link__nOLLk","arrow":"MenuLink_arrow__jC8eu"};